export const EVENT_VIDEO_DURATION_SEC = 6;
export const EVENT_BBOX_DURATION = 2500; // 2.5 sec
export const EVENTS_HISTORY_LIMIT = 20;

export const EventNameColorMap = {
  // Frequent events
  BASKET_LOADING_BEGIN: '#3B82F6',
  BASKET_LOADING_END: '#7C3AED',
  PAN_ON_CONVEYOR_INBOUND: '#EA580C',
  PAN_ON_CONVEYOR_OUTBOUND: '#E11D48',
  PAN_IN_HOT_HOLDING_MOVED: '#16A34A',
  PAN_IN_HOT_HOLDING_PLACED: '#84CC16',
  PAN_ID_UPDATED: '#0891B2',
  PAN_FROM_HOT_HOLDING_REMOVED_INTERNAL: '#0D9488',
  CHICKEN_PAN_BATCH_ZERO: '#DB2777',
  FRYER_CYCLE_STARTED: '#D97706',
  FRYER_CYCLE_COMPLETED: '#EAB308',
  
  // Breading / fryer / basket / pan workflow
  BREADING_BEGIN: '#C2410C',
  BREADING_END: '#4F46E5',
  CHICKEN_TRANSPORT_TO_FRYER_BEGIN: '#65A30D',
  CHICKEN_TRANSPORT_TO_FRYER_END: '#BE185D',
  CHICKEN_BASKET_IN_OIL_PLACED: '#06B6D4',
  FRYER_COOK_CYCLE_BEGIN: '#B45309',
  FRYER_COOK_CYCLE_END: '#6D28D9',
  CHICKEN_BASKET_OUT_OIL: '#22C55E',
  BASKET_IN_CTS_PLACED: '#BE123C',
  BASKET_INTO_PAN_DUMPED: '#2563EB',
  CHICKEN_TRANSPORT_TO_ASSEMBLY_CENTER_BEGIN: '#4D7C0F',
  CHICKEN_TRANSPORT_TO_ASSEMBLY_CENTER_END: '#A21CAF',
  PAN_WEIGHT_ESTIMATED: '#0F766E',
  PAN_FROM_HOT_HOLDING_REMOVED: '#C65D0A',
  EMPTY_MATERIAL_REJECTED: '#4338CA',
  MATERIAL_FROM_PAN_REMOVED: '#16A34A',
  CHICKEN_PACKAGING: '#DB2777',
  PACKAGE_IN_CHUTE_PLACED: '#0284C7',
  PACKAGE_IN_CHUTE_REMOVED: '#CA8A04',
  MATERIAL_TO_PAN_ADDED: '#9333EA',
  PAN_TRANSPORT_TO_PRS_BEGIN: '#15803D',
  PAN_TRANSPORT_TO_PRS_END: '#E11D48',
  PAN_FROM_PRS_REMOVED: '#1D4ED8',
  PAN_IN_PRS_PLACED: '#65A30D',
  PAN_IN_PRS_PLACED_INTERNAL: '#C026D3',
  PAN_IN_PRS_MOVED: '#0F766E',
  PAN_TO_SCRAP_DUMPED: '#EA580C',
  TIMER_MATERIAL_UPDATED: '#5B21B6',
  PAN_ID_RESET: '#4D7C0F',
  CHICKEN_BATCH_REJECTED: '#BE185D',
  MERCO_TRAY_PLACED: '#0891B2',
  MERCO_TRAY_REMOVED: '#A16207',
  RFID_TRAY_PLACED: '#7E22CE',
  RFID_TRAY_REMOVED: '#16A34A',
  RFID_INVENTORY: '#DC2626',
  WRONG_MATERIAL_IN_PAN_DETECTED: '#1E40AF',
  
  // Timer / temperature
  TIMER_EXPIRED: '#A3A314',
  TEMP_NOW: '#C02664',
  
  // Detection
  PAN_OVERLAP_DETECTED: '#14B8A6',
  PAN_OVERLAP_UNDETECTED: '#EA8A15',
  ARUCO_MARKERS_OVERLAP_DETECTED: '#6D28D9',
  ARUCO_MARKERS_OVERLAP_UNDETECTED: '#65A30D',
  CAMERA_POLLUTION_DETECTED: '#DB2777',
  CAMERA_POLLUTION_UNDETECTED: '#0891B2',
  UNRECOGNIZED_CHICKEN_PAN_DETECTED: '#CA8A04',
  UNSUITABLE_WEIGHT_BATCH_DETECTED: '#9333EA',
  UNRECOGNIZED_PAN_IN_PRS_PLACED: '#16A34A',
  BREADING_TABLE_PAN_OVERLAP_DETECTED: '#DC2626',
  BREADING_TABLE_PAN_OVERLAP_UNDETECTED: '#2563EB',
  BREADING_TABLE_PAN_INSIDE_PAN_DETECTED: '#84CC16',
  BREADING_TABLE_PAN_INSIDE_PAN_UNDETECTED: '#C026D3',
  UNRECOGNIZED_BASKET_IN_OIL_PLACED: '#0D9488',
  HOOD_FRYER_OVERLAP_DETECTED: '#EA580C',
  HOOD_FRYER_OVERLAP_UNDETECTED: '#4338CA',
  HOOD_FRYER_OPEN_LID_DETECTED: '#22C55E',
  HOOD_FRYER_OPEN_LID_UNDETECTED: '#E11D48',
  UNEXPECTED_OBJECT_DETECTED: '#0284C7',
  UNEXPECTED_OBJECT_UNDETECTED: '#A3A314',
  PAN_IN_PRS_NOT_PLACED: '#A21CAF',
  
  // Detection state updates
  UNRECOGNIZED_CHICKEN_PAN_UPDATE_STATE: '#0F766E',
  UNSUITABLE_WEIGHT_BATCH_UPDATE_STATE: '#C2410C',
  UNRECOGNIZED_PAN_IN_PRS_UPDATE_STATE: '#1D4ED8',
  UNRECOGNIZED_BASKET_IN_OIL_UPDATE_STATE: '#65A30D',
  
  // Monitoring
  MONITORING_PLATE_PLACED: '#DB2777',
  MONITORING_PLATE_REMOVED: '#14B8A6',
  
  // Marker / pan validation
  WRONG_MARKER_DETECTED: '#D97706',
  IDENTICAL_MARKERS_DETECTED: '#7C3AED',
  EMPTY_PAN_DETECTED: '#16A34A',
  CHICKEN_TIMERS_UPDATED: '#BE185D',
  
  // PRQ
  PAN_IN_PRQ_PLACED: '#0284C7',
  PAN_FROM_PRQ_REMOVED: '#CA8A04',
  PAN_FROM_PRQ_REMOVED_INTERNAL: '#9333EA',
  PAN_IN_PRQ_MOVED: '#0D9488',
  PRQ_PAN_ID_UPDATED: '#DC2626',
  PRQ_PAN_WEIGHT_ESTIMATED: '#2563EB',
  PRQ_PAN_EMPTIED: '#65A30D',
  SCRAP_TO_PAN_ADDED: '#C02664',
  SCRAP_FROM_PAN_REMOVED: '#0891B2',
  PRQ_CHICKEN_BATCH_REJECTED: '#D97706',
  PRQ_PAN_FILLED: '#5B21B6',
  
  // Breading result
  BREADING_MATERIAL_UPDATED: '#16A34A',
  BREADING_REJECTED: '#E11D48',
  
  // Package chutes
  PACKAGE_IN_CHUTES_PLACED: '#1D4ED8',
  PACKAGE_FROM_CHUTES_REMOVED: '#A3A314',
  PACKAGES_IN_CHUTES_UPDATED: '#DB2777',
  PACKAGE_REJECTED: '#14B8A6',
  
  // Entree chutes lane configuration
  ENTREE_CHUTES_LANE_CONFIG_UPDATED: '#EA580C',
  
  // Entree chutes lane mismatch
  ENTREE_CHUTES_LANE_MISMATCH_WARNING: '#4F46E5',
  ENTREE_CHUTES_LANE_MISMATCH_RESOLVED: '#16A34A',
  
  // Package validation
  WRONG_PACKAGE_DETECTED: '#BE123C',
};
